<template>
  <Loader :loader="loaderActive"/>
  <div class="py-4 container-fluid">
    <div class="row" style="">
      <div class="category-head">
        <div class="back-link">
          <a @click="$router.back()"> <i class="fas fa-chevron-left"></i></a>
        </div>
        <div class="category-title">
          <p class="pt-3" style="font-weight: bold"> {{ $t('NOTIFICATIONS') }} </p>
        </div>
        <router-link class="search-friend-icon" to="/find-friends">
          <i class="fa fa-search"></i>
        </router-link>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="notification-content" v-for="notification in notifications" :key="notification.id">
          <div class="d-flex justify-content-between" style="margin-bottom: 7px;">
            <div class="title">{{ notification.title }}</div>
            <div class="notification-date">{{ notification.datetime }}</div>
          </div>
          <div class="notification-details">{{ notification.body }}</div>
        </div>
      </div>
    </div>
    <DashboardFooterMenu/>
  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";
import DashboardFooterMenu from "@/views/components/DashboardFooterMenu";

export default {
  name: "Notification",
  components: {
    Loader,
    DashboardFooterMenu
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      notifications: [],
    }
  },
  created() {
    this.getNotifications();
  },
  methods: {
    getNotifications() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/promotions', {}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.notifications = response.data;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
  }
}
</script>

<style scoped>

</style>
